<template>
    <div class="stream-screenshot">
        <div class="stream-screenshot__read" v-if="!isAllowEdit">
            <StreamScreenshotValue
                v-if="isServerFile"
                :value="value"
                :filename="filename"
            />
            <a v-else class="screenshot-name" :href="value" target="_blank" rel="noopener">{{ filename }}</a>
        </div>

        <div class="stream-screenshot__edit" v-else-if="isEdit && isAccessAllow">
            <EditText
                v-model.trim="editable"
                @cancel="cancel"
                @apply="apply"
                @paste="paste"
            />
        </div>

        <div class="stream-screenshot__read" v-else-if="value">
            <template v-if="isServerFile">
                <StreamScreenshotValue
                    :value="value"
                    :filename="filename"
                />
                <Attach v-if="isAccessAllow" @change="uploadScreenshot"/>

                <Icon v-if="isAccessAllow" class="ml-1" id="delete" color="purple" @click="updateScreenshot(null)"/>
            </template>
            <template v-else>
                <a class="screenshot-name" :href="value" target="_blank" rel="noopener">{{ filename }}</a>
                <Icon v-if="isAccessAllow" id="edit" @click="isEdit = true"/>
                <Icon v-if="isAccessAllow" class="ml-1" id="delete" color="purple" @click="updateScreenshot(null, 'screenshot_url')"/>
            </template>
        </div>

        <div class="stream-screenshot__edit" v-else>
            <template v-if="isAccessAllow">
                <Icon id="edit" @click="isEdit = true"/>
                <Attach @change="uploadScreenshot"/>
            </template>
        </div>
    </div>
</template>

<script>
import StreamScreenshotValue from "@/vue/plan/url/Task/StreamScreenshotValue";
import Attach from "@common/vue/components/form/Attach";
import EditText from "@common/vue/components/form/EditText";

export default {
    name: "StreamScreenshot",
    components: {EditText, Attach, StreamScreenshotValue},
    props: ['isAccessAllow', 'value', 'streamId', 'safe'],
    data() {
        return {
            isEdit: false,
            editable: '',
        }
    },
    computed: {
        isAllowEdit() {
            return Boolean(this.streamId);
        },
        isServerFile() {
            return Boolean(true === this.safe);
        },
        filename() {
            return this.value.split('/').at(-1);
        },
    },
    methods: {
        uploadScreenshot(files) {
            this.updateScreenshot(files[0] || null);
        },
        apply() {
            if (this.editable.length) {
                this.updateScreenshot(this.editable, 'screenshot_url');
            }

            this.isEdit = false;
        },
        paste(value) {
            this.editable = value.trim();
            if (this.editable.length) {
              this.updateScreenshot(this.editable, 'screenshot_url');
            }

            this.isEdit = false;
        },
        cancel() {
            this.editable = this.value;
            this.isEdit = false;
        },
        updateScreenshot(screenshot, field = 'screenshot') {
            if (!this.streamId) return;

            this.$store.dispatch('updatePlanUrlStream', {
                streamId: this.streamId,
                field: field,
                value: screenshot,
            }).catch((err) => {
                this.editable = '';
                this.$emit('error', err.response.data.message);
            });
        },
    }
}
</script>

<style>
.stream-screenshot {
  color: red;
}
.stream-screenshot .stream-screenshot__read {
    display: flex;
    align-items: center;
}

.stream-screenshot .screenshot-name {
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    font-weight: 400;
    font-size: 14px;
    text-decoration-line: underline;
    color: #30B68F;
    white-space: nowrap;
}
</style>
